module.exports = __webpack_public_path__ + "img/15东莞源杰.cf8d2803.gif";